
/* injects from baggage-loader */
require('./style.scss');

import React, { Component } from 'react';
import KeyboardedInput from 'react-touch-screen-keyboard';
import 'react-touch-screen-keyboard/lib/Keyboard.scss';
import PropTypes from "prop-types";
import { connect } from "react-redux";

class KeyboardInput extends Component {
    constructor (props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.handleClickForClearInput = this.handleClickForClearInput.bind(this);
        this.state = {
            text: ""
        };
        this.clearInputField = this.clearInputField.bind(this);
    }

    static getDerivedStateFromProps(props) {
        if (Object.prototype.hasOwnProperty.call(props, 'value')) return { text: props.value };
        return null;
    }

    clearInputField () {
        this.props.clearSearchFiled && this.props.clearSearchFiled();
        !this.props.value && this.setState({ text: "" });
    }
    handleChange (text) {
        this.props.onChange && this.props.onChange(text);
        this.props.casino && window.liveCasinoEventSource.postMessage({action: 'writeNickName', text: text}, '*');
        !this.props.value && this.setState({text});
    }
    componentDidMount () {
        if (this.props.setFocus) {
            document.getElementsByClassName(this.props.class ? this.props.class : "input-field-v single-form-item")[0].focus();
        }
    }
    handleClickForClearInput () {
        this.setState({text: null});
    }
    render () {
        const CustomMapping = this.props.numeric ? [
            ['1', '2', '3'],
            ['4', '5', '6'],
            ['7', '8', '9'],
            ['*bs', '0', ...this.props.customKeys],
        ] : [
            ['q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p'],
            ['a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l', '@'],
            ['z', 'x', 'c', 'v', 'b', 'n', 'm', ...this.props.customKeys]
        ];
        return (
            <div>
                <KeyboardedInput
                    enabled
                    type={this.props.type}
                    onChange={this.handleChange}
                    value={this.state.text}
                    name="myInput"
                    placeholder={this.props.placeholder}
                    defaultKeyboard={CustomMapping}
                    isDraggable={false}
                    isFirstLetterUppercase={false}
                    showShift={!this.props.numeric}
                    showSymbols={!this.props.numeric}
                    showNumericRow={!this.props.numeric}
                    showSpacebar={!this.props.numeric}
                    inputClassName={this.props.class || 'input-field-v single-form-item'}
                    keyboardClassName={this.props.numeric ? 'keyboard-numeric' : ''}
                />
                {
                    this.props.enableClearButton && <i className="icon-closed" onClick={this.clearInputField}/>
                }
            </div>
        );
    }
}

KeyboardInput.defaultProps = {
    customKeys: []
}

KeyboardInput.propTypes = {
    type: PropTypes.string,
    onChange: PropTypes.func,
    placeholder: PropTypes.string,
    casino: PropTypes.bool,
    numeric: PropTypes.bool,
    class: PropTypes.string,
    setFocus: PropTypes.bool,
};
export default connect()(KeyboardInput);